import axios, { CancelToken } from 'apis';
import { sessionService } from 'redux-react-session';
import { getThunkActionCreator } from 'redux-thunk-routine';
import {
  getStatusRoutine,
  refreshStatusRoutine,
  clearLocalStatusRoutine
} from 'actions';

export const getStatus = getThunkActionCreator(
  getStatusRoutine,
  async () => {
    getStatus.getStatusCancel && getStatus.getStatusCancel();
    const { token: access_token } = await sessionService.loadSession();

    return await axios.get('/user/status', {
      params: { access_token },
      cancelToken: new CancelToken(function executor(c) { getStatus.getStatusCancel = c })
    });
  }
);

export const refreshStatus = getThunkActionCreator(
  refreshStatusRoutine,
  async () => {
    const { token: access_token } = await sessionService.loadSession();

    return await axios.post('/user/status/refresh', { access_token });
  }
);

export const clearLocalStatus = getThunkActionCreator(
  clearLocalStatusRoutine,
  async () => {}
);

